import { Atom, atom } from 'jotai';
import { rawCyclesAtom } from '@/atoms/queries/cycles';
import { seasonLookupAtom } from '@/atoms/queries/seasons';
import { convertToDropdownOption } from '@/utils/object';

// Season options derived from every cycle the user can access (not the primary entity's own cycles).
export const createUserScopedSeasonOptionsAtom = (competitionIdsAtom: Atom<number[]>) =>
  atom(async get => {
    const competitionIds = get(competitionIdsAtom);
    if (!competitionIds.length) return [];

    const [{ data: cycles }, seasonLookup] = await Promise.all([get(rawCyclesAtom), get(seasonLookupAtom)]);
    const filteredCycles = cycles.filter(cycle => competitionIds.includes(cycle.competition_id));
    const uniqueSeasonIds = [...new Set(filteredCycles.map(cycle => cycle.season_id))];

    return uniqueSeasonIds
      .flatMap(seasonId => {
        const season = seasonLookup.get(seasonId);
        return season ? [convertToDropdownOption(season.name, season.season_id)] : [];
      })
      .sort((a, b) => b.label.localeCompare(a.label));
  });
